module.exports = __webpack_public_path__ + "img/newbanner_01.30b92ad6.png";